import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function () {
  const navigate = useNavigate();
  const [ref, setRef] = useState(1);
  const [progressPercentage, setProgressPercentage] = useState(2);
  const [showError, setShowError] = useState(false);
  const [questions, setQuestions] = useState([
    {
      id: 1,
      question: "I have often inspired positive organizational shifts",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 2,
      question: "My work is thorough and excellent ",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 3,
      question: "I easily influence groups",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 4,
      question: "I have a good understanding of my weaknesses",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 5,
      question: "I follow through with my vision plans",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 6,
      question: "I have a low turnover of those who work under me",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 7,
      question: "I have sensitivity and understanding of others ",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 8,
      question: "I can delegate sufficiently",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 9,
      question: "I can see leaders who I have mentored and trained. ",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 10,
      question: "I have a good track record",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 11,
      question: "I write down my vision for the future",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 12,
      question: "I understand why I am created",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 13,
      question: "I have completed milestone projects",
      category: "Transformative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    //second
    {
      id: 14,
      question:
        "I often draw people to me but keeping them can, at times, be challenging.",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 15,
      question: "I feel more comfortable administrating than having to lead",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 16,
      question: "Can easily link up with people",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 17,
      question:
        "I get easily frustrated with others when they do not complete their tasks",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 18,
      question: "I am a good manager",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 19,
      question: "I have mentored junior members",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 20,
      question: "I am more comfortable doing everything rather than delegating",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 21,
      question:
        "I focus more on my level rather than how the whole network works.",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 22,
      question: "I find it hard to coach others",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 23,
      question:
        "If things are not moving, I instinctively take over and do it myself.",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 24,
      question: "I understand my character type",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 25,
      question: "I feel connected to my environment",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 26,
      question: "I feel like I am self-made",
      category: "Administrative Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    //third
    {
      id: 27,
      question: "There is a sense of emptiness in my environment",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },

    {
      id: 28,
      question: "It is often difficult to get people to do what I want",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 29,
      question: "I easily procrastinate",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 30,
      question: "I get anxious when asked to take the lead",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 31,
      question: "I am more comfortable completing tasks by myself",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 32,
      question: "I often ignore challenges that are too hard",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 33,
      question: "I do not understand why I lose good team members ",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 34,
      question: "Making connections with others can be a challenge",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 35,
      question: "It is hard to rally people behind me ",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 36,
      question: "I prefer focusing on my tasks to dealing with others. ",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 37,
      question: "It is challenging to complete my vision projects",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 38,
      question: "My focus is getting to retirement",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 39,
      question: "I am not good at future vision planning",
      category: "Emerging Leader",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
  ]);
  const [count, setCount] = useState(0);
  const inputElement = useRef("1");
  function nextHandler() {
    // console.log(
    //   "idxcheck",
    //   questions[count].options.findIndex((v) => v.isSelected === true),
    //   questions[count].options
    // );
    if (
      questions[count].options.findIndex((v) => v.isSelected === true) !== -1
    ) {
      setShowError(false);
      if (count < questions.length - 1) {
        setCount(count + 1);
      }
    } else setShowError(true);
  }
  const handleClick = (op, topG) => {
    console.log(op, topG);
    setShowError(false);
    console.log(topG.options.findIndex((val) => val.id == op.id));
    let idx = topG.options.findIndex((val) => val.id == op.id);
    questions[count].options.forEach((op) => (op.isSelected = false));
    questions[count].options[idx].isSelected = true;
    console.log("category", topG.category, op.score);
    // op.isSelected = true;

    // console.log(e.currentTarget.textContent);
    // console.log(e.currentTarget);
    // if (e.currentTarget.textContent == "No") {
    //   console.log("BIG NO");
    // } else if (e.currentTarget.textContent == "Yes") {
    //   console.log("BIG YES");
    // } else {
    //   console.log("BIG SW");
    // }
    if (count < questions.length - 1) {
      setCount(count + 1);
      setProgressPercentage(progressPercentage + 2.4);
    } else {
      navigate("/form");
      console.log("elseeeeeeeee");
      let filteredFirst = questions.filter(
        (val) => val.category === "Transformative Leader"
      );
      let filteredSecond = questions.filter(
        (val) => val.category === "Transformative Leader"
      );
      let filteredThird = questions.filter(
        (val) => val.category === "Emerging Leader"
      );
      //   let filteredFourth = questions.filter(
      //     (val) => val.category === "Explorer"
      //   );
      //   let reduced = filteredFirst.filter(
      //     (val) => val.options.findIndex((itm) => itm.isSelected === true) !== -1);
      //.reduce((total = 0, curr) => total + curr.score);
      //   let reduced = filteredFirst.filter((op) =>
      //     op.options.find((v) => v.isSelected === true)
      //   );
      let score1 = 0;
      let score2 = 0;
      let score3 = 0;
      //   let score4 = 0;
      for (let i = 0; i < filteredFirst.length; i++) {
        for (let j = 0; j < filteredFirst[i].options.length; j++) {
          if (filteredFirst[i].options[j].isSelected) {
            score1 = score1 + filteredFirst[i].options[j].score;
          }
        }
      }
      for (let i = 0; i < filteredSecond.length; i++) {
        for (let j = 0; j < filteredSecond[i].options.length; j++) {
          if (filteredSecond[i].options[j].isSelected) {
            score2 = score2 + filteredSecond[i].options[j].score;
          }
        }
      }
      for (let i = 0; i < filteredThird.length; i++) {
        for (let j = 0; j < filteredThird[i].options.length; j++) {
          if (filteredThird[i].options[j].isSelected) {
            score3 = score3 + filteredThird[i].options[j].score;
          }
        }
      }
      //   for (let i = 0; i < filteredFourth.length; i++) {
      //     for (let j = 0; j < filteredFourth[i].options.length; j++) {
      //       if (filteredFourth[i].options[j].isSelected) {
      //         score4 = score4 + filteredFourth[i].options[j].score;
      //       }
      //     }
      //   }
      localStorage.setItem("Type", "Second");
      localStorage.setItem("Type2", "Second");
      localStorage.setItem("score1", score1);
      localStorage.setItem("score2", score2);
      localStorage.setItem("score3", score3);
      //   localStorage.setItem("score4", score4);
      console.log("score1", score1, (score1 / 40) * 100);
      console.log("score2", score2, (score2 / 40) * 100);
      console.log("score3", score3, (score3 / 40) * 100);
      //   console.log("score4", score4, (score4 / 40) * 100);
    }
    // console.log(inputElement.current.innerText, "ref");
  };
  const previousHandler = () => {
    setShowError(false);
    if (count > 0) {
      setCount(count - 1);
    }
  };
  return (
    <div className="text-center ">
      <div className="flex flex-col justify-center items-start m-auto w-7/12 ">
        {/* {questions.map((ques) => {
          return ( */}
        <div id="custom-animation" className="w-full">
          {/* question */}

          <div className="text-start m-3 flex flex-row">
            {questions[count].question} &nbsp;
            {showError ? (
              <p className="text-red-500">'Select an option'</p>
            ) : (
              ""
            )}
            {/* {ques.question} */}
          </div>
          {/* top     ref={inputElement}*/}
          <div className="flex flex-row flex-wrap justify-center items-center m-auto  w-full">
            {questions[count].options.map((op) => {
              return (
                <div
                  key={op.id}
                  onClick={() => handleClick(op, questions[count])}
                  className={
                    op.isSelected
                      ? "bg-yellow-300 bg-opacity-30 block p-6 w-full md:w-3/12 m-3  rounded-lg border border-gray-200 shadow-md  cursor-pointer"
                      : "block p-6 w-full md:w-3/12 m-3 bg-white rounded-lg border border-gray-200 shadow-md  cursor-pointer "
                  }
                >
                  <p className="font-normal text-gray-900 ">{op.op}</p>
                </div>
              );
            })}
            {/* <div
                  onClick={handleClick}
                  className="block p-6  w-full md:w-3/12 m-3 bg-white rounded-lg border border-gray-200 shadow-md cursor-pointer"
                >
                  <p className="font-normal text-gray-900 ">Some what</p>
                </div>
                <div
                  onClick={handleClick}
                  className="block p-6 w-full md:w-3/12 m-3 bg-white rounded-lg border border-gray-200 shadow-md cursor-pointer"
                >
                  <p className="font-normal text-gray-900 ">No</p>
                </div> */}
          </div>
          <br />
        </div>
        {/* );
        })} */}

        {/* bottom */}
        <div className="flex flex-row w-full justify-between items-center m-auto ">
          {/* left-arrow */}
          <div
            onClick={previousHandler}
            className="w-3/12 md:w-1/12 p-2 m-2 bg-yellow-300 rounded-full bg-opacity-20 cursor-pointer"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </div>
          {/* progress-bar */}
          <div className="w-6/12 md:w-9/12 bg-yellow-300 bg-opacity-30 rounded-full h-1.5 mb-1 ">
            <div
              className="bg-primary h-1.5 rounded-full "
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
          {/* right-arrow */}
          <div
            onClick={nextHandler}
            className="w-3/12 md:w-1/12 p-2 m-2 bg-yellow-300 rounded-full bg-opacity-20 cursor-pointer"
          >
            <i className="fa-solid fa-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
